<template>
	<div class="instruction-container" @click="closeModal">
		<div class="instruction-background"></div>
		<div class="instruction-box">
			<div class="header">{{ item.inventoryType }}</div>
			<div class="instruction-text">{{ item.instruction }}</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		item: {
			type: Object
		}
	},
	methods: {
		closeModal() {
			this.$emit('close');
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";
.instruction-container {
  z-index: 3;
  position: fixed;
  display: flex;
  width: 100%;
  padding: 1rem;
  padding-top: 4rem;
  height: 100%;
  top: 0;
  left: 0;
}
.instruction-background {
  position: absolute;
  background: $shadow-color;
  margin: -1rem;
  width: 100%;
  height: 100%;
}
.instruction-box {
  position: relative;
  z-index: 2;
  width: 100%;
  padding: 1rem;
  margin: auto;
  background: white;
  border: 1px solid grey;
  border-radius: 2px;
  .instruction-text {
    white-space: pre-wrap;
  }
  .header {
    font-weight: bold;
  }
}
</style>
